import {tariffsFromApi} from '../../dialogs/block/tariffs/apiModel'
import type {Tariff, TariffFieldKey} from '../../dialogs/block/tariffs/model'
import {formatPrice, normalizePrice} from '../../dialogs/block/tariffs/price'

export const publicTariffs = (settings: unknown): Tariff[] => {
  if (!Array.isArray((settings as any)?.tariffs)) return []
  return tariffsFromApi(settings).filter(tariff => publicFields(tariff).length > 0)
}

export const publicComponentVisible = (component: {hidden?: boolean; type?: string; data?: unknown}) =>
  component.hidden !== true && (component.type !== 'tariffs' || publicTariffs(component.data).length > 0)

export const publicFields = (tariff: Tariff): TariffFieldKey[] => {
  const order: TariffFieldKey[] = ['image', 'name', ...tariff.order]
  return order.filter(key => {
    const field = tariff.fields[key]
    if (!field.enabled) return false
    if (key === 'image') return !!(field.image?.imageId || field.image?.editedSrc || field.value.trim())
    if (key === 'advantages') return !!field.items?.some(item => item.text.trim())
    if (key === 'price') return normalizePrice(field.value) !== null && field.value.trim() !== ''
    return field.value.trim() !== ''
  })
}

export const publicPrice = (value: string, unit = '₸') => {
  const [currency, period] = unit.split('/')
  return `${formatPrice(value)} ${currency}${period ? `/${period}${period === 'мес' ? '.' : ''}` : ''}`
}
